import React, { useEffect, useState, useCallback } from "react";
import "./Modal.css";
import HttpClient from "../utils/HttpClient";
import RewardPoints from "../utils/RewardPoints";

const ProductViewModal = ({ closemodal, ProductItem, profile }) => {
  // const productPoint = async () => {
  //   await HttpClient.requestData("getting-rewards", "POST", { profileId: profile?._id, type: RewardPoints.PRODUCT_VIEW_TYPE });
  // }

  //  await HttpClient.requestData("getting-rewards", "POST", { profileId: profile?._id, type: RewardPoints.PRODUCT_VIEW_TYPE });

  // useEffect(() => {
  //   productPoint()
  // }, [])

  return (
    <>
      <div className="productmodal">
        {ProductItem && (
          <div className="productmodalcontent">
            <div className="icklohjj" onClick={() => closemodal()} style={{cursor:"pointer"}}>
              <i
                className="fa-solid fa-xmark"
                style={{ cursor: "pointer" }}
              ></i>
            </div>
            <div className="">
              <div className="prcdgimgj">
                <img src={ProductItem?.image} alt="..." />
              </div>
              <div className="divtstxmodal">
                <h4 className="prdcttctx">{ProductItem?.name}</h4>
                <p className="unjktxtt">{ProductItem?.description}</p>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default ProductViewModal;
